import { inject, Injectable } from '@angular/core';
import { Adapter } from '../models/adapter.model';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserAdapter implements Adapter<User> {

  adaptFromServer(item: any): User {
    return {
      id: item?.id,
      slug: item?.slug,
      name: item?.name,
      username: item?.username,
      firstName: item.first_name,
      lastName: item.last_name,
      gender: item.gender,
      dob: item.dob,
      email: item?.email,
      phoneNumber: item?.phone_number,
      active: item?.active,
      role: item?.role,
      accountType: item?.account_type,
      accountTypeId: item.account_type === 'council' ? item.managed_council_id :
                     item.account_type === 'crc' ? item.crc_id : undefined,
      primaryAccountType: item.primary_account_type,
      primaryRole: item.primary_role,
      activeContext: item.active_context,
      availableContexts: item.available_contexts ?? [],
      councilRole: item.council_role ? {
        id: item.council_role.id,
        name: item.council_role.name,
        slug: item.council_role.slug,
        protectedReadOnly: item.council_role.protected_read_only,
      } : null,
      permissions: item.permissions ?? [],
      staffMembership: item.staff_membership ?? null,
    };
  }
}
